<!-- Priviledge -->
<script lang="ts" setup>
    import { onBeforeMount, computed } from 'vue';
    import "../../css/choice.css"
    import { usePrivilegesStore } from '../lib/Stores/PrivilegesStore'
    import { initPinia } from '../lib/PiniaMgr';
    import { AppScreens, PrivilegeType } from '../Enums/ChoiceEnums';
    import { IUserScreenRights } from '../lib/Models/User/UserScreenRights';
    import AccessRestrictedMsg from './Messages/AccessRestrictedMsg.vue'

    const privilegesStore = usePrivilegesStore(initPinia());

    const props = defineProps<{
        screen: AppScreens,
        privilege: PrivilegeType,
        showRestriction?: boolean
    }>();

    const userPrivilege = computed<PrivilegeType>(() => 
    {
        return privilegesStore.screens[props.screen];
    });
    const isAllowed = computed<boolean|undefined>(() => {
        if (undefined === userPrivilege.value)
            return;
        return userPrivilege.value >= props.privilege;
    });

    onBeforeMount(async () =>{
        await privilegesStore.getScreen(props.screen);
    });

    const userRights = computed<IUserScreenRights>(() => {
        return {
            screen: props.screen,
            userPrivilege: userPrivilege.value,
            requiredPrivilege: props.privilege
        };
    });

</script>

<template>
    <template v-if="true === isAllowed">
        <slot></slot>
    </template>

    <slot name="notAllowed" v-if="false === isAllowed" :rights="userRights">
        <AccessRestrictedMsg :rights="userRights" v-if="showRestriction" />
    </slot>
</template>